import useSWR from 'swr';
import {useIntl} from 'react-intl';
import React, {useCallback, useMemo} from 'react';
import {useHistory, useParams} from 'react-router';

import {PreProcessingForm} from './PreProcessingForm';
import {toast} from '../../../base-components/StudioToast';
import {
  preProcessorNew,
  PreProcessorNewRequest,
  PreProcessorNewUrl,
} from '../../../api/preprocessor/PreProcessorNew';
import {
  preProcessorUpdate,
  PreProcessorUpdateRequest,
} from '../../../api/preprocessor/PreProcessorUpdate';

export const CreatePreProcessor = () => {
  const {projectId} = useParams<{projectId: string}>();
  const requestParams: PreProcessorNewRequest = useMemo(
    () => ({
      projectId,
      transformationType: 'SCRIPT',
    }),
    [projectId]
  );
  const cacheKey = useMemo(() => PreProcessorNewUrl(requestParams), [requestParams]);
  const {data} = useSWR(cacheKey, () => preProcessorNew(requestParams), {
    revalidateOnFocus: false,
    revalidateOnReconnect: false,
  });

  const intl = useIntl();
  const history = useHistory();

  const handleCancel = useCallback(() => {
    history.push(`/project/${projectId}/upload`);
  }, [history, projectId]);

  const handleSubmit = useCallback(
    async (values: PreProcessorUpdateRequest) => {
      try {
        const resp = await preProcessorUpdate(values);

        if (!resp.errors?.length) {
          toast.success(intl.formatMessage({id: 'createPreProcessor.success'}));
          history.push(`/project/${projectId}/upload`);
        }
      } catch (e) {
        console.error(e);
      }
    },
    [history, intl, projectId]
  );

  return (
    <PreProcessingForm
      projectId={projectId}
      template={data?.body}
      onSubmit={handleSubmit}
      onCancel={handleCancel}
      title={intl.formatMessage({id: 'createPreProcessor.header'})}
    />
  );
};
